
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from "react-redux";
import registerServiceWorker from './registerServiceWorker';
import './config.js';
import './i18n/config';
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import setupInterceptors from "./services/setupInterceptors";



const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
ReactDOM.render(
  <BrowserRouter>
    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>,
  rootElement);

setupInterceptors(store);

registerServiceWorker();

